module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "card-calendar dashboard-card dashboard-card--bordered dashboard-card--hoverable"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Client',
        params: {
          clientId: _vm.item.clientId
        }
      }
    }
  }, [_c('div', {
    staticClass: "card-calendar__wrapper"
  }, [_c('div', {
    staticClass: "card-calendar__time"
  }, [_c('img', {
    staticClass: "card-calendar__icon",
    attrs: {
      "src": _vm.IconClock,
      "alt": ""
    }
  }), _vm._v(" "), _c('time', {
    attrs: {
      "datetime": _vm.item.datetime || ''
    }
  }, [_vm._v(_vm._s(_vm.$moment(_vm.item.hour.start).format('HH:mm')))])]), _vm._v(" "), _c('div', {
    staticClass: "card-calendar__content"
  }, [_c('div', {
    staticClass: "card-calendar__header"
  }, [_c('h4', {
    staticClass: "dashboard-card__name"
  }, [_vm._v(_vm._s(_vm.item.customer))]), _vm._v(" "), _c('span', {
    staticClass: "card-calendar__type-badge",
    class: _vm.getTypeBadgeClass(_vm.item.type)
  }, [_vm._v(_vm._s(_vm.item.type))])]), _vm._v(" "), _c('p', {
    staticClass: "card-calendar__subject"
  }, [_vm._v(_vm._s(_vm.item.description))])]), _vm._v(" "), _c('svg', {
    staticClass: "dashboard-card__arrow",
    attrs: {
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7.5 15L12.5 10L7.5 5",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a33de63"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Board/CardCalendar.vue
// module id = 1104
// module chunks = 0